import account from './account'
import customer from './customer'
import invoice from './invoice'
import message from './message'
import officialAccount from './officialAccount'
import business from './business'
import personalInvoices from './personalInvoices'
import ukeyBox from './ukeyBox'
import reim from './reimbursement'
import sso from './sso'

export const accountRequest = account.request
export const customerRequest = customer.request
export const invoiceRequest = invoice.request
export const messageRequest = message.request
export const officialAccountRequest = officialAccount.request
export const businessRequest = business.request
export const personalInvoicesRequest = personalInvoices.request
export const ukeyBoxRequest = ukeyBox.request
export const reimRequest = reim.request
export const ssoRequest = sso.request
